__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2025-11-19-1763557804-beta-dev/";